import { Button, DialogClose } from "web-design-system";
import { useMemo } from "react";
import { SuccessLottieAnimation } from "web-core";
import { GiftKycAmc } from "creso-core/types";

interface SuccessStepProps {
  clientName: string;
  amc: GiftKycAmc;
  signed?: boolean;
}

export function SuccessStep({ clientName, amc, signed }: SuccessStepProps) {
  const nextSteps = useMemo(
    () =>
      signed
        ? [
            <>
              AMC will take 2–3 business days for{" "}
              <span className="font-semibold">folio creation.</span>
            </>,
            <>
              {clientName} can <span className="font-semibold">transact</span>{" "}
              after folio creation.
            </>,
          ]
        : [
            amc === "HDFC" ? (
              <>
                {clientName} would have received an email to complete a{" "}
                <span className="font-semibold">liveness check</span> and{" "}
                <span className="font-semibold">sign</span> the form.
              </>
            ) : (
              <>
                {clientName} would have received an email to{" "}
                <span className="font-semibold">sign</span> the form.
              </>
            ),
            <>
              Once signed, AMC will take 2-3 business days for{" "}
              <span className="font-semibold">folio creation.</span>
            </>,
            <>
              They can <span className="font-semibold">transact</span> after
              folio creation.
            </>,
          ],
    [signed, clientName, amc]
  );

  return (
    <div className="flex flex-col h-full text-center gap-6">
      <div className="flex flex-col flex-1 items-center justify-center">
        <SuccessLottieAnimation height={150} width={150} loop={false} />
        <div className="flex flex-col gap-8">
          <span className="text-lg font-bold text-foreground">
            {signed ? "Form Signed" : "Form Completed"}
          </span>
          <div className="bg-slate-100 flex flex-col max-w-lg gap-3 rounded-lg p-4 text-left w-full">
            <span className="text-sm font-semibold text-foreground">
              Next Steps:
            </span>
            <ol className="flex flex-col gap-3">
              {nextSteps.map((step, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm text-foreground"
                >
                  <div className="size-5 items-center justify-center flex">
                    <span className="shrink-0 w-4 h-4 rounded-full bg-foreground text-background flex items-center justify-center text-xs">
                      {i + 1}
                    </span>
                  </div>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-auto">
        <DialogClose asChild>
          <Button size="lg">Done</Button>
        </DialogClose>
      </div>
    </div>
  );
}
